export const getHrefParamFromLocation = (paramName, newHref) => {
    let href = newHref || '';
    let search = '';
    // 2024-12-22 调整参数获取逻辑：原来是优先获取search，没有再获取hash。现在改成两者拼接，因为后面正则匹配是优先匹配,实际匹配效果和原来一致
    if (global.location) {
      search += global.location.search;
      let _hash = global.location.hash.split('?');
      if (_hash.length > 1) {
        _hash.splice(0, 1);
        let curHashParams = _hash.join('&');
        search += '&' + curHashParams;
      }
    }
    href = search.replace(/^\?/, '');
    let reg = new RegExp('(^|&|\\?)' + paramName + '=([^&]*)(&|$)');
    let matchResult = href.match(reg);
    let param = '';
    if (matchResult !== null && matchResult.length > 0) {
      try {
        param = decodeURIComponent(matchResult[2]);
      } catch {
        if (/\%/.test(matchResult[2])) {
          matchResult[2] = matchResult[2].replace(/\%/g, '$replace$');
          param = decodeURIComponent(matchResult[2]);
          param = param.replace(/\$replace\$/g, '%');
        } else {
          param = matchResult[2];
        }
      }
    }
    if (param === 'in-ID') param = 'id-ID';
    if (
      paramName == 'gameId' ||
      paramName == 'gameID' ||
      paramName == 'game_id'
    ) {
      param = param.replace(/\D[^]*$/, '');
    }
    return param;
  };